import { render, staticRenderFns } from "./AdminRemind.vue?vue&type=template&id=d89fa4fc&scoped=true&"
import script from "./AdminRemind.vue?vue&type=script&lang=js&"
export * from "./AdminRemind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89fa4fc",
  null
  
)

export default component.exports